export interface Permissions {
  readonly FEATURE_LIVE_MODE: boolean;
  readonly FEATURE_PRIVATE_ROUTES: boolean;
  readonly LIMIT_ROUTES: number;
  readonly LIMIT_ROUTE_PLACES: number;
}

export interface Plan {
  readonly name: string;
  readonly tag?: string;
  readonly id: keyof Plans;
  readonly permissions: Permissions;
}

export interface Plans {
  readonly FREE: Plan;
  readonly PLUS: Plan;
}

export const PLANS: Plans = {
  FREE: {
    name: 'Tripply Free',
    tag: '',
    id: 'FREE',
    permissions: {
      FEATURE_LIVE_MODE: false,
      FEATURE_PRIVATE_ROUTES: false,
      LIMIT_ROUTES: 3,
      LIMIT_ROUTE_PLACES: 35
    }
  },
  PLUS: {
    name: 'Tripply Plus',
    tag: 'PLUS',
    id: 'PLUS',
    permissions: {
      FEATURE_LIVE_MODE: true,
      FEATURE_PRIVATE_ROUTES: true,
      LIMIT_ROUTES: 10,
      LIMIT_ROUTE_PLACES: 100
    }
  }
}
